<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill="#8DC512" />
        <path
            d="M7.66669 16.0002C7.66669 12.8575 7.66669 11.2861 8.643 10.3098C9.61931 9.3335 11.1907 9.3335 14.3334 9.3335H17.6667C20.8094 9.3335 22.3807 9.3335 23.357 10.3098C24.3334 11.2861 24.3334 12.8575 24.3334 16.0002C24.3334 19.1429 24.3334 20.7142 23.357 21.6905C22.3807 22.6668 20.8094 22.6668 17.6667 22.6668H14.3334C11.1907 22.6668 9.61931 22.6668 8.643 21.6905C7.66669 20.7142 7.66669 19.1429 7.66669 16.0002Z"
            stroke="white"
            stroke-width="1.16667"
        />
        <path
            d="M11 12.6665L12.7991 14.1657C14.3296 15.4412 15.0949 16.0789 16 16.0789C16.9051 16.0789 17.6704 15.4412 19.2009 14.1657L21 12.6665"
            stroke="white"
            stroke-width="1.16667"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
export default {
    name: "LetterInCircleIcon",
};
</script>
